
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Blvx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $46ab5fe8ff64b9e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $46ab5fe8ff64b9e1$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': 'Analysegegevens vernieuwen ...',
    'confluence-analytics-chart.tooltip.no-views-data': 'Geen gegevens',
    'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 weergave} other {{count} weergaven}}',
    'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, one {1 weergave tot nu toe} other {{count} weergaven tot nu toe}}',
    'confuence-analytics-chart.accessible-table.caption': 'Paginaweergaven',
    'confuence-analytics-chart.accessible-table.header.date': 'Datum',
    'confuence-analytics-chart.accessible-table.header.view-count': 'Weergaven',
    'confuence-analytics-chart.accessible-table.no-view-count-data': 'Geen weergaven'
};

});


//# sourceMappingURL=nl.691b8f54.js.map
